<template>
  <section class="how-it-works">
    <div class="container">
      <hr>

      <h2>The Smart Way to <span>Buy a Car</span></h2>

      <p class="how-it-works__subtext">
        Save time and money. Get approved for a car loan before you start shopping.
      </p>

      <div class="row row--gutter-100">
        <div class="col col--xs-12 col--sm-4 how-it-works__col">
          <div class="how-it-works__step">
            <img
              class="how-it-works__img"
              :src="require('@/assets/img/landing-page/how-it-works/easy-approval.jpg')"
            >

            <h3>Easy Online<span> Approval</span></h3>

            <p class="how-it-works__text">
              Any credit accepted! Apply for financing online in under three minutes
              and we will find the best financing options in your area.
            </p>
          </div>
        </div>

        <div class="col col--xs-12 col--sm-4 how-it-works__col">
          <div class="how-it-works__step">
            <img
              class="how-it-works__img"
              :src="require('@/assets/img/landing-page/how-it-works/save-time-shopping.jpg')"
            >

            <h3>Save Time<span> Shopping</span></h3>

            <p class="how-it-works__text">
              You will be matched with a local Certified Dealership that will only
              show you vehicles you are pre-approved for. No more rejection.
            </p>
          </div>
        </div>

        <div class="col col--xs-12 col--sm-4 how-it-works__col">
          <div class="how-it-works__step">
            <img
              class="how-it-works__img"
              :src="require('@/assets/img/landing-page/how-it-works/get-driving-in-48-hours.jpg')"
            >

            <h3>Get Driving in<span> 48 Hours</span></h3>

            <p class="how-it-works__text">
              Here comes the fun part! Choose the car you want and drive away,
              the entire process typically takes under 48 hours!
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  // Name
  name: 'how-it-works'
}
</script>

<style scoped lang="scss">
$bordercolor: #DBDBDB;

.how-it-works {
  margin-top: -60px;

  .container {
    hr {
      background-color: $bordercolor;
      height: 1px;
      border: none;
      margin-top: 160px;
      margin-bottom: 100px;
    }
  }

  &__subtext {
    @include breakpoint('mobile-only') {
      margin-bottom: 32px;
    }
  }

  h2, h3, &__subtext {
    @include breakpoint('mobile-only') {
      text-align: center;
    }
  }

  h2 span {
    @include breakpoint('mobile-only') {
      display: block;
    }
  }

  h3 span {
    @include breakpoint('tablet-portrait-up') {
      display: block;
    }
    @include breakpoint('tablet-landscape-up') {
      display: inline;
    }
  }

  &__subtext span {
    @include breakpoint('mobile-small-only') {
      display: block;
    }
  }

  &__col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__img {
    width: 92px;
    position: relative;
    display: block;
    margin-top: 25px;

    @include breakpoint('mobile-only') {
      margin: 0 auto;
      margin-top: 32px;
    }

    @include breakpoint('mobile-small-only') {
      margin-top: 22px;
    }
  }

  &__text,
  &__text small {
    @include breakpoint('mobile-only') {
      text-align: center;
    }
  }
}
</style>
